<template>
    <div>
        <Haloween/>
    </div>
</template>

<script>
import Haloween from '../../components/zzHalloween/Halloween.vue';
export default {
    name: 'SolimanologHaloween',
    components: { Haloween },
    data() {
        return {};
    },
    mounted() {
    },
    methods: {},
    
};
</script>

<style lang="scss" scoped>

</style>